import type { FaqItem } from "@/types/content";

export const billingFaqs: FaqItem[] = [
  {
    question: "Does this website currently accept payment?",
    answer:
      "This marketing site (devory.app) does not embed a checkout form directly, but real self-serve checkout is live: sign in to Devory Cloud (app.devory.app), open Settings > Billing, choose a plan, and pay through Stripe. Builder, Professional, Studio and Team can all be purchased today.",
  },
  {
    question: "Is Devory's pricing final?",
    answer:
      "The prices shown on the pricing page are Devory's real, final V1 prices for Creator, Builder, Professional, Studio, Team and Enterprise -- not placeholders, and they match the live Stripe prices exactly.",
  },
  {
    question: "How do subscriptions work?",
    answer:
      "Subscriptions are billed on a recurring basis (monthly or annual) through Stripe, with clear terms shown before purchase. You can change or cancel a plan from Settings > Billing inside Devory Cloud at any time.",
  },
  {
    question: "Where are the cancellation and refund terms?",
    answer:
      "See the Cancellation Policy and Refund Policy in the legal hub for the governing terms.",
  },
  {
    question: "How do enterprise agreements differ from self-serve plans?",
    answer:
      "Enterprise engagements are scoped individually through a direct conversation with Devory, and any signed enterprise agreement takes precedence over the standard public terms for that customer.",
  },
  {
    question: "Can the Creator plan publish to the Marketplace for free?",
    answer:
      "The real Marketplace publishing pipeline (publisher accounts, listings, entitlement-gated orders) is live and free to use at every plan, including Creator -- component supply is what makes the Marketplace valuable, so it's deliberately not a paid-only capability. No listings have been published to the public catalogue yet.",
  },
  {
    question: "What actually differs between the plans today?",
    answer:
      "Three things are real and server-enforced today: how many private workspaces you can have (1 on Creator, 5 on Builder, unlimited from Professional up), how many people can share an organisation (1 on Creator/Builder/Professional, 5 on Studio, 10 on Team), and how many scoped cloud-workflow executions per month you get (0 on Creator, rising by plan -- see each card). Export/deployment and broader AI cloud compute are direction Devory is building toward; see each plan's \"Coming later\" section.",
  },
];

export const supportFaqs: FaqItem[] = [
  {
    question: "How do I get help with Devory today?",
    answer:
      "Use the contact form and select the category that matches your question. Devory is in active development, so response times can vary while the team is small.",
  },
  {
    question: "Is there a guaranteed response time?",
    answer:
      "Not yet. Devory does not publish a guaranteed service-level response time for the current stage of the product. This will be revisited as support operations mature.",
  },
  {
    question: "What do I do if I think I found a security issue?",
    answer:
      "Use the contact form and select the Security category so it reaches the right people. See the Security page for more detail on responsible reporting.",
  },
  {
    question: "Where do billing questions go?",
    answer:
      "Use the contact form and select the Support category, or manage your subscription directly from Settings > Billing inside Devory Cloud.",
  },
];
